import * as React from 'react'
import { LanguageForm } from './LanguageForm'
import { Language } from 'models/language'
import { Loading } from 'components/Loading'
import { useTranslation } from 'react-i18next'
import { StorageProvider } from 'providers/storage'
import { AVAILABLE_LANGUAGES } from 'i18n'
import { ApiProvider } from 'providers/request'

function setCookie(cname: string, cvalue: string, exdays: number) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const ConnectedLanguageForm: React.FC = (_props) => {
  const { t, i18n } = useTranslation()
  const [languages] = React.useState<Language[]>(
    AVAILABLE_LANGUAGES.map((languageCode) => {
      return { code: languageCode, label: t(`languages.${languageCode}`) }
    }),
  )

  const updateLanguage = async (language: string) => {
    if (StorageProvider.set('language', language)) {
      setCookie("language", language, 365);
      await i18n.changeLanguage(language)
      ApiProvider.patch(`/me`, { "language": language })

      return
    } else {
      throw Error
    }
  }

  if (languages.length < 1) {
    return <Loading />
  }

  const language = StorageProvider.get('language')

  if (language !== 'es' && language !== 'en') {
    StorageProvider.set('language', 'es');
    i18n.changeLanguage('es');
  }

  try {
    if (typeof i18n.language == 'undefined') {
      StorageProvider.set('language', 'es');
      i18n.changeLanguage('es');
    }
  } catch (e) {
    console.log(e);
  }


  return (
    <LanguageForm
      language={{ code: i18n.language, label: t(`languages.${i18n.language}`) }}
      languages={languages}
      submit={updateLanguage}
    />
  )
}
